import { CompareSharp } from "@mui/icons-material";
import Pagination from "react-js-pagination";
import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import {
  Link,
  Routes,
  Route,
  useParams,
  useNavigate,
  Outlet,
} from "react-router-dom";
import Committeegnb from "./Committeegnb";
import "./Committeeprocess.scss";
function Committeeprocess() {
  const { id } = useParams();
  const [commPostData, setCommPostData] = useState([]);
  const [commpageId, setCommpageId] = useState([]);
  const [page, setPage] = useState(1);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  let navigate = useNavigate();

  const handlePageChange = (page) => {
    getCommitteeDetailMenu(page);
    setPage(page);
  };

  const getCommitteeDetailMenu = async (page) => {
    try {
      const response = await axios.get(`/api/committee-meeting`, {
        params: {
          committeeTypeId: id,
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      // console.log(response.data.data);
      setCommPostData(response.data.data);
      setRecords(response.data);
      setTotalItems(response.data.recordsFiltered);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCommitteeDetailMenu();
  }, [id]);

  return (
    <>
      <Committeegnb id={commpageId} />
      <div className="">
        <div className="">
          <div className="my_page bbs_contain">
            <div className="row_bbs bbs_customqa_wrap">
              <table className="table_wrap_customerqa">
                <thead>
                  <tr>
                    <th style={{ flex: "0.1" }}>번호</th>
                    <th style={{ flex: "0.2" }}>회의차수</th>
                    <th style={{ flex: "0.4" }}>회의일정</th>
                    <th style={{ flex: "0.4" }}>회의장소</th>
                    <th style={{ flex: "0.4" }}>회의 안건</th>
                  </tr>
                </thead>
                <tbody>
                  {commPostData.map((value) => {
                    return (
                      <tr key={value.id}>
                        <td style={{ flex: "0.1" }}>{value.num}</td>
                        <td className="num_bbs" style={{ flex: "0.2" }}>
                          {value.times}
                        </td>
                        <td style={{ flex: "0.4" }}>
                          <p>{value.startDate}</p>
                        </td>
                        <td style={{ flex: "0.4" }}>
                          <p className="auth">{value.location}</p>
                        </td>
                        <td style={{ flex: "0.4" }} className="date_bbs">
                          {value.topic}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {commPostData.length > 0 ? null : (
                <span style={{ textAlign: "center", marginTop: "10vh" }}>
                  등록된 목록이 없습니다
                </span>
              )}
              <div className="pagination_wrap">
                <div></div>
                <div className="pagination">
                  <Pagination
                    activePage={page}
                    itemsCountPerPage={5}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    prevPageText={"‹"}
                    nextPageText={"›"}
                  />
                </div>
                <div>
                  <button
                    style={{ visibility: "hidden" }}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("");
                    }}
                    className="list_btn"
                  >
                    {/* 목록 */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Committeeprocess;
